import { GraphQLTableColumn } from "../../GraphQL";
import NumberColumn from "./NumberColumn";

export function IdColumnTemplate<T extends object = {}>(params?: GraphQLTableColumn<T>): GraphQLTableColumn<T> {
  return NumberColumn<T>(params);
}

export default IdColumnTemplate;
